<template>
    <div
        id="workposts-menu-page"
        class="grid grid-cols-[repeat(20,_minmax(0,_1fr))] items-stretch gap-8 p-4">
        <div
            class="menuitem automenuitem"
            v-for="autoItem in autoItems.filter((x) => x.visible)"
            :style="{ backgroundColor: autoItem.color }"
            @click="clickAutoItem(autoItem)">
            <h2>{{ autoItem.label }}</h2>
        </div>
    </div>
</template>
<script>
import workstationApi from '../api/workstation';
import { loadPage } from '../helpers/NavigationHelper';

export default {
    data() {
        return {
            autoItems: [],
        };
    },
    methods: {
        clickAutoItem(workpost) {
            if (workpost.customView) {
                loadPage(workpost.customView);
            } else {
                this.$router.push('/workpostscanproduct/' + workpost.id);
            }
        },
    },
    mounted() {
        workstationApi.fetchWorkstationsForMenu().then((response) => {
            this.autoItems = response.data.data;
        });
    },
};
</script>
